import styled from 'styled-components';
import { maxMediaQueries, minMediaQueries } from '@finect/tabular-utils/mediaQueries';

export const CardList = styled.div`
  margin: -9px -15px 30px;

  ${minMediaQueries.phone`
    margin-left: -9px;
    margin-right: -9px;
  `};
`;

export const CardItemList = styled.div`
  margin-bottom: 30px;

  ${maxMediaQueries.phone`
    margin-left: -15px;
    margin-right: -15px;
  `};
`;
